import axios from 'axios';
import { API_BASE_URL } from '../config/config';

const sendKycVerifyData = async (data) => {
    return await axios.post(`${API_BASE_URL}/aadhaar/okyc/otp/request`, data);
};

const validateOtp = async (data) => {
    return await axios.post(`${API_BASE_URL}/aadhaar/okyc/otp/verify`, data);
};

const verifyTokenExpiry = async (token) => {
    return await axios.get(`${API_BASE_URL}/aadhaar/verify-token?token=${token}`);
};

export default {
    sendKycVerifyData,
    validateOtp,
    verifyTokenExpiry
};


